import React, { useState, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { Menu } from 'antd';
import './NavLanguage.scss';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { changeLanguage } from '../../../redux/actions/user.action';
import { getLanguageDisplayLabel } from '../../../helpers/i18n';

const { SubMenu } = Menu;

const defaultLanguageCodes = ['en', 'vi'];

const mapLanguageLabels = (languages) =>
  languages.map((lg) => ({
    value: lg.value,
    label: getLanguageDisplayLabel(lg.value),
  }));

function NavLanguage({ user, mvp, changeLanguage }) {
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [menuTitle, setMenuTitle] = useState('');
  const [listLanguage, setListLanguage] = useState([]);

  // Memoize mvpListLanguage to prevent infinite loops
  const mvpListLanguage = useMemo(() => {
    return mvp?.listLanguage || [];
  }, [mvp?.listLanguage]);

  useEffect(() => {
    // Nếu user chưa đăng nhập, lấy ngôn ngữ từ sessionStorage, mặc định là tiếng Anh
    if (!user?.accessToken || !user?.authenticated) {
      // Lấy ngôn ngữ từ sessionStorage, nếu không có thì mặc định 'en'
      const sessionLanguage = sessionStorage.getItem('ced:session-language');
      const language = sessionLanguage || 'en';
      setCurrentLanguage(language);
      
      // Sử dụng mvpListLanguage nếu có, nếu không thì dùng defaultLanguageList
      const languagesToUse = mvpListLanguage.length > 0
        ? mvpListLanguage
        : defaultLanguageCodes.map((value) => ({ value }));

      const mappedListLanguage = mapLanguageLabels(languagesToUse);
      setListLanguage(mappedListLanguage);
      const currentLanguageObj = mappedListLanguage.find(lg => lg.value === language);
      if (currentLanguageObj) {
        setMenuTitle(currentLanguageObj.label);
      }
      return;
    }

    // Nếu user đã đăng nhập, sử dụng ngôn ngữ từ user.language (từ DB)
    // user.language từ API có format {value: 'en'|'vi', label: 'English'|'Tiếng Việt'}
    let language = 'en'; // Mặc định là tiếng Anh
    if (user.language) {
      // Lấy value từ language object (từ API getInfoUser)
      if (typeof user.language === 'object' && user.language.value) {
        language = user.language.value;
      } else if (typeof user.language === 'string') {
        language = user.language;
      }
    }
    setCurrentLanguage(language);

    if (mvpListLanguage.length) {
      const mappedListLanguage = mapLanguageLabels(mvpListLanguage);
      setListLanguage(mappedListLanguage);
      const currentLanguageObj = mappedListLanguage.find(lg => lg.value === language);
      if (currentLanguageObj) {
        setMenuTitle(currentLanguageObj.label);
      }
    }
  }, [mvp?.listLanguage, user?.language, user?.accessToken, user?.authenticated]);

  const handleClick = async ({ key }) => {
    const language = listLanguage.find(lg => lg.value === key);

    if (!language) {
      return
    }
    setMenuTitle(language.label);

    if (user?.accessToken && user?.authenticated) {
      // User đã đăng nhập: cập nhật ngôn ngữ trong database
      try {
        const result = await changeLanguage(key);
        if (result.status === 'ok') {
          // Sau khi lưu thành công, reload để áp dụng ngôn ngữ mới
          // changeLanguage đã fetch lại user và cập nhật Redux state
          setTimeout(() => {
            window.location.reload()
          }, 100)
        } else {
          console.error('Failed to update language in database:', result.message);
        }
      } catch (error) {
        console.error('Failed to update language in database:', error);
      }
    } else {
      // User chưa đăng nhập: lưu vào sessionStorage (sẽ tự xóa khi đóng tab)
      sessionStorage.setItem('ced:session-language', key);
      // Also update localStorage for API calls
      localStorage.setItem('ced:language', key);
      
      // Đợi một chút để đảm bảo sessionStorage được lưu
      setTimeout(() => {
        window.location.reload()
      }, 100)
    }
  };

  return (
    <>
      {listLanguage.length ? <Menu
        onSelect={handleClick}
        selectedKeys={[currentLanguage]}
        className="menu-language"
        mode="horizontal"
        getPopupContainer={(triggerNode) => triggerNode.parentElement}
        theme="dark"
      >
        <SubMenu
          key="sub1"
          title={menuTitle}
          icon={<FontAwesomeIcon icon={faAngleDown} />}
          popupClassName="submenu-language"
        >
          {listLanguage.map(language =>
            <Menu.Item key={language.value}>{language.label}</Menu.Item>
          )}
        </SubMenu>
      </Menu>: null}
    </>
  );
};

const mapStateToProps = ({ user, mvp }) => ({ user, mvp });
const mapDispatchToProps = {
  changeLanguage
};

export default connect(mapStateToProps, mapDispatchToProps)(NavLanguage);
